import React from 'react';
import {
  fetchDataFromLinkQueryParam,
  setNewLinkQueryParam,
  useAgentSchedulerDispatchContext,
  useAgentSchedulerStateContext,
} from 'Context/NewAgentSchedulerContext';
import DateNavigator from 'Components/UI/Calendar/DateNavigator';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import moment from 'moment';
import { fullDateISO } from 'Consts/DateFormats';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import MonthlyCalendar from 'Components/UI/Calendar/Monthly';
import SchedulerWeeklyCount from './SchedulerWeeklyCount';
import CalendarLegend from './CalendarLegend';
import CalendarSidebar from './CalendarSidebar';
import SchedulerPicklist from './SchedulerPicklist';
import SchedulerDayWithWeekends from './SchedulerDayWithWeekends';

const MonthCalendarContainer = () => {
  const { loading, currentCollection, projectedMeetingCollection } = useAgentSchedulerStateContext();
  const dispatch = useAgentSchedulerDispatchContext();
  const { logEvent } = useEventTrackingLogEvent();

  const availabilityPeriodResource = currentCollection.resources().head();
  const projectedMeetingResource = projectedMeetingCollection?.resources().head();
  const currentDate = moment(availabilityPeriodResource.attr('currentDate'));
  const prevDate = moment(availabilityPeriodResource.attr('prevDate'));
  const nextDate = moment(availabilityPeriodResource.attr('nextDate'));

  const goToPrevMonth = () => {
    setNewLinkQueryParam(dispatch, availabilityPeriodResource.link('prev').url());
    fetchDataFromLinkQueryParam(dispatch);
  };

  const goToNextMonth = () => {
    setNewLinkQueryParam(dispatch, availabilityPeriodResource.link('next').url());
    fetchDataFromLinkQueryParam(dispatch);
  };

  const handleDayNumberClick = (selectedDate, availabilityDayResource) => {
    logEvent('Clicked Date from Scheduler Monthly View', { selectedDate });
    dispatch({ type: 'setSelectedDate', selectedDate });
    setNewLinkQueryParam(dispatch, availabilityDayResource.relationship(fr.relationships.availabilityForWeek.name).link('related').url());
    fetchDataFromLinkQueryParam(dispatch);
  };
  const availabilityDayItems = availabilityPeriodResource.attr('availabilityDays').resources().list().map(resource => ({
    resource,
    projectedMeetingResource,
    date: moment.utc(resource.attr('day')).format(fullDateISO),
  }));
  const DayComponent = SchedulerDayWithWeekends;
  return (
    <>
      <DateNavigator
        date={currentDate}
        prevDate={prevDate}
        nextDate={nextDate}
        goToPrevDate={goToPrevMonth}
        goToNextDate={goToNextMonth}
        goToNextDateEventName="Clicked Next Month From MC Scheduler"
        goToPrevDateEventName="Clicked Previous Month From MC Scheduler"
        isLoading={loading}
      />
      { availabilityPeriodResource && pickFunction(availabilityPeriodResource, {
        [fr.relationships.schedulerAgents.name]: (<SchedulerPicklist />),
        [fr.relationships.default.name]: () => (<></>),
      })}
      <MonthlyCalendar
        date={currentDate}
        onDayNumberClick={handleDayNumberClick}
        items={availabilityDayItems}
        DayComponent={DayComponent}
      >
        {availabilityPeriodResource && <CalendarSidebar
          availabilityPeriodResource={availabilityPeriodResource}
        />}
        <SchedulerWeeklyCount />
      </MonthlyCalendar>
      <CalendarLegend />
    </>
  );
};

export default MonthCalendarContainer;
